module.exports = __webpack_public_path__ + "img/banner_phone.60a9a7bc.png";